module.exports = __webpack_public_path__ + "img/postgres.9318272b.svg";